import { render, staticRenderFns } from "./ClientVotes.vue?vue&type=template&id=255738f6&"
import script from "./ClientVotes.vue?vue&type=script&lang=js&"
export * from "./ClientVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports